export default "__VITE_ASSET__5851d317__"